import { render } from "./HistoricShow.vue?vue&type=template&id=4f7dec68&scoped=true"
import script from "./HistoricShow.vue?vue&type=script&lang=js"
export * from "./HistoricShow.vue?vue&type=script&lang=js"

import "./HistoricShow.vue?vue&type=style&index=0&id=4f7dec68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7dec68"]])

export default __exports__